import { env as SERVER_URL } from '@/components/utils/env';
import { formSwal, sanitizeJSONString } from '@/components/utils/common';
import * as globaljs from '@/components/utils/global';

async function aiorder_status_update(data) {
	/*
		const data = {
			aiorder_id: aiorder_id,
			order_status: obj.value,
			aiorder_no: aiorder_no
		};
	*/
	// 전달받은 데이터를 URLSearchParams에 추가
	const params = new URLSearchParams();
	for (const [key, value] of Object.entries(data)) {
		params.append(key, value);
	}
	// URLSearchParams를 객체로 변환
	const object = {};
	params.forEach((value, key) => {
		if (key.endsWith('[]')) {
			const arrayKey = key.slice(0, -2);
			if (!object[arrayKey]) {
				object[arrayKey] = [];
			}
			object[arrayKey].push(value);
		} else {
			object[key] = value;
		}
	});

	// 결과 확인용 로그 출력
	const jsonString = JSON.stringify(object, null, 2); // 들여쓰기 2칸으로 JSON 문자열화
console.info(jsonString);

	let items = null;
	let orderJsonData = null;

	try {
		let response = await axios.get(`${SERVER_URL}/api/app/aiorder/${data.aiorder_id}`);
console.debug('aiorder_status_update()', response.data.result);
		items = response.data.result;

		// 241022 파싱할때 특수문자 오류. sanitizeJSONString함수 추가.
		const sanitizedData = sanitizeJSONString(items.order_json_data);
		orderJsonData = JSON.parse(sanitizedData);

console.debug(orderJsonData);

	} catch (error) {
		formSwal(`데이터 수신 오류(get_aiorders)`, error);
	}
	
	if (data.order_status === 'ords2' || data.order_status === 'ords3') {
		if (orderJsonData.patientName === '') {
			return { result: 'error', msg: '환자명을 입력해 주세요.'};
		}
		if (orderJsonData.completeHopeDate === '') {
			return { result: 'error', msg: '희망완료일을 입력해 주세요.'};
		}
		if (orderJsonData.infection === '') {
			return { result: 'error', msg: '감염성 질환을 선택해 주세요.'};
		}
		if (orderJsonData.registerDate === '') {
			return { result: 'error', msg: '주문일을 선택해 주세요.'};
		}
	}
console.log( data.order_status );
	if (data.order_status === 'ords3') {
		let prosthesis_cnt = parseInt(orderJsonData.prosthesis_cnt, 10);
		prosthesis_cnt = isNaN(prosthesis_cnt) || prosthesis_cnt <= 0 ? 0 : prosthesis_cnt;
console.log('data-prosthesis_cnt: ', prosthesis_cnt);

		if (prosthesis_cnt < 1) {
			return { result: 'error', msg: `의뢰내용(보철물) 정보가 없습니다. 추가해서 작성해 주세요.`};
		} else {
			for (let i=1; i<=prosthesis_cnt; i++) {
				if ( orderJsonData[`options_${i}`] === '' || orderJsonData[`detail_${i}`] === '' || typeof orderJsonData[`teeth_${i}`] === 'undefined' || orderJsonData[`teeth_${i}`] === undefined ) {
					return { result: 'error', msg: `${i}번째의 의뢰내용(보철물) 정보를 정확히 작성해 주세요.`};
				}
			}
		}
	}

	params.append('mb_id', items.mb_id || globaljs.mb_boss_id); // 2024-10-29 null 방지
	params.append('lab_id', items.lab_mb_id);
	params.append('hos_id', items.hospital_mb_id);

	try {
		let response = await axios.put(`${SERVER_URL}/api/app/aiorder/status`, params);
console.debug(response.data.result);
		if (response.data.result.message === 'OK') {
			return { result: 'success', msg: '주문 제작상태 변경 완료!' };
		} else {
			return { result: 'error', msg: `주문 제작상태 변경 실패(${response.data.result.message})` };
		}

	} catch (error) {
		console.error('Error getModels:', error);
		return { result: 'error', msg: '주문 제작상태 변경 중 오류 발생' };
	}
}

async function talk_send(data) {
	const params = new URLSearchParams();
	params.append('mb_boss_id', data.mb_boss_id);
	params.append('other_id', data.other_id);
	params.append('content', data.content);
	if (data.aiorder_id) {
		params.append('aiorder_id', data.aiorder_id);
	}
	
	// URLSearchParams를 객체로 변환
	const object = {};
	params.forEach((value, key) => {
		if (key.endsWith('[]')) {
			const arrayKey = key.slice(0, -2);
			if (!object[arrayKey]) {
			object[arrayKey] = [];
			}
			object[arrayKey].push(value);
		} else {
			object[key] = value;
		}
	});

	// 결과 확인용 로그 출력
	const jsonString = JSON.stringify(object, null, 2); // 들여쓰기 2칸으로 JSON 문자열화
console.info(jsonString);

	try {
		let response = await axios.post(`${SERVER_URL}/api/app/talk`, params);
console.debug(response.data.result);
		if (response.data.result.message === 'OK') {
			return { result: 'success', msg: '톡 전송 완료!' };
		} else {
			return { result: 'error', msg: '톡 전송 실패' };
		}

	} catch (error) {
		console.error('Error getModels:', error);
		return { result: 'error', msg: '톡 전송중 오류 발생' };
	}
}

async function staff_rank_update(data) {
	console.debug('staff_rank_update js: ', data );
	/*
		const data = {
			aiorder_id: aiorder_id,
			order_status: obj.value,
			aiorder_no: aiorder_no
		};
	*/
	// 전달받은 데이터를 URLSearchParams에 추가
	const params = new URLSearchParams();
	for (const [key, value] of Object.entries(data)) {
		params.append(key, value);
	}

	// URLSearchParams를 객체로 변환
	const object = {};
	params.forEach((value, key) => {
		if (key.endsWith('[]')) {
			const arrayKey = key.slice(0, -2);
			if (!object[arrayKey]) {
				object[arrayKey] = [];
			}
			object[arrayKey].push(value);
		} else {
			object[key] = value;
		}
	});

	// 결과 확인용 로그 출력
	const jsonString = JSON.stringify(object, null, 2); // 들여쓰기 2칸으로 JSON 문자열화
console.info(jsonString);
/*
	{
		"mb_id": "labsub0830",
		"mb_staff": "Manager"
	}
*/

	try {
		let response = await axios.put(`${SERVER_URL}/api/app/member/staff`, params );
console.debug(response.data.result);
		if (response.data.result.message === 'OK') {
			return { result: 'success', msg: '직원권한 변경 완료!' };
		} else {
			return { result: 'error', msg: '직원권한 변경 실패' };
		}

	} catch (error) {
		console.error('Error getModels:', error);
		return { result: 'error', msg: '직원권한 변경 중 오류 발생' };
	}
}

export { aiorder_status_update, talk_send, staff_rank_update }